import { render, staticRenderFns } from "./Krecommendations.vue?vue&type=template&id=62e8b84c"
import script from "./Krecommendations.vue?vue&type=script&lang=js"
export * from "./Krecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports